/**
 * Mobile navigation toggle
 */
const navbar = () => {
  const toggleBtn = document.querySelector(".mobile-toggle-cta");
  const nav = document.querySelector(".navbar");
  const closeBtn = document.querySelector(".navbar .close-cross");
  const body = document.body;
  const BP_MD = 768;

  if (!toggleBtn || !nav || !closeBtn) return;

  const menuCount = nav.querySelectorAll(".navbar-nav > li").length;
  nav.style.setProperty("--menu-count", menuCount);

  function openMenu() {
    nav.classList.add("-open");
    body.classList.add("menu-open");
    toggleBtn.setAttribute("aria-expanded", "true");
  }

  function closeMenu() {
    nav.classList.remove("-open");
    body.classList.remove("menu-open");
    toggleBtn.setAttribute("aria-expanded", "false");
  }

  toggleBtn.addEventListener("click", openMenu);
  closeBtn.addEventListener("click", closeMenu);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && nav.classList.contains("-open")) {
      closeMenu();
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth >= BP_MD) {
      closeMenu();
    }
  });
};

navbar();

export default navbar;
